import React from 'react';
import { Navigate } from 'react-router-dom';

import { useCohortLayoutContext } from './CohortLayout';
import CohortDiscussions from './CohortDiscussions';

/**
 * Route wrapper for the moderation panel. The threads endpoint 403s for a plain
 * member, so — like the Members view — they are redirected to Cohort Info.
 */
const CohortDiscussionsView: React.FC = () => {
  const { detail, canModerate } = useCohortLayoutContext();

  if (!canModerate) {
    return <Navigate to={`/cohorts/${detail.slug}/info`} replace />;
  }

  return <CohortDiscussions slug={detail.slug} language={detail.language} />;
};

export default CohortDiscussionsView;
